export class DealerTarget {
    TargeID: number;
    DealerID: number;
    DealerName: string;
    TargetYear: string;
    TargetValue: any;
    IsActive : Boolean = true;
}
